export const FROALA3_LECENSE_KEY = 'lSA3D-17C1E1F2H2F2I1rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2B2D6B1B2C4F1D3==';

// Grupos sin '|': Froala los saca de su grupo al rehacer la barra por breakpoint.
export const toolbarButtons = [
  ['bold', 'italic', 'underline', 'strikeThrough', 'backgroundColor', 'fontSize', 'textColor', 'clearFormatting', 'subscript', 'superscript', 'quote'],
  ['mathButtonV3', 'insertLink', 'html'],
  ['numGroup', 'formatOL', 'formatUL', 'outdent', 'indent', 'lineHeight', 'alignCenter', 'alignJustify', 'alignLeft', 'alignRight'],
  ['insertTable'],
  ['undo', 'redo'],
];

export const miniToolbarButtons = ['bold', 'italic', 'underline', 'textColor', 'mathButtonV3'];

const TOOLBAR_VARIANTS = new Map([
  [toolbarButtons, 'maxi'],
  [miniToolbarButtons, 'mini'],
]);

export function getToolbarVariant(buttons) {
  return TOOLBAR_VARIANTS.get(buttons) ?? null;
}

export const extraConfigDefault = {
  toolbarButtons: miniToolbarButtons,
  toolbarButtonsMD: miniToolbarButtons,
  toolbarButtonsSM: miniToolbarButtons,
  toolbarButtonsXS: miniToolbarButtons,
  quickInsertEnabled: false,
};

export const extraConfigNoTabTrap = {
  ...extraConfigDefault,
  tabSpaces: false,
};

export const scriptsEnabled = [
  'align',
  'alignWithDefault',
  'codeBeautifier',
  'codeView',
  'colors',
  'quote',
  'draggable',
  'entities',
  'fontSize',
  'fullscreen',
  'inlineStyle',
  'lineBreaker',
  'link',
  'lists',
  'paragraphFormat',
  'save',
  'url',
  'wordPaste',
  'table',
  'mathPluginv3',
];
